import React, { Component } from 'react'
import styled from 'styled-components'
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'
import './slider.css'

import FaCalendar from 'react-icons/lib/fa/calendar'
import FaMapMarker from 'react-icons/lib/fa/map-marker'

export default class Slider extends Component {
    rendering = (lang) => {
      const responsive = {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        1024: {
          items: 3
        }
      }

      const { data } = this.props

      return (
        <AliceCarousel
          responsive={responsive}
          duration={3000}
          autoPlay
          startIndex={0}
          fadeOutAnimation
          mouseDragEnabled
          infinite={false}
        >
          {
            Object.values(data[lang].events).map((item, index) => {
              return (
                <Item key={index}>
                  <a href={item.url} target='_blank' rel='noopener noreferrer'>
                    <ItemTitle>
                      {item.title}
                    </ItemTitle>
                    <ItemInfo>
                      <Icon>
                        <FaCalendar />
                      </Icon>
                      <Text>
                        <span dangerouslySetInnerHTML={{ __html: item.dateTime }} />
                      </Text>
                    </ItemInfo>
                    <ItemInfo>
                      <Icon>
                        <FaMapMarker />
                      </Icon>
                      <Text>
                        {item.location}
                      </Text>
                    </ItemInfo>
                  </a>
                </Item>
              )
            })
          }
        </AliceCarousel>
      )
    }

    render () {
      return (
        <span>
          {
            this.props.i18n.language === 'pt' &&
                        this.rendering('pt')
          }
          {
            this.props.i18n.language === 'en' &&
                        this.rendering('en')
          }
        </span>
      )
    }
}

const Item = styled.div`
    background-color: white;
    padding: 20px;
    margin: 10px;
`
const ItemTitle = styled.div`
    color: #000000;
    font-size: 16px;
    font-weight: 600;   
    margin-bottom: 8px;
`
const ItemInfo = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`
const Icon = styled.div`
    margin-right: 5px;
    color: #2E84C6;
`
const Text = styled.div`
    opacity: 0.6;
    color: #000000;
    font-size: 14px;
`



// WEBPACK FOOTER //
// ./src/components/slider/slider.js